var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlaceholderAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.5C9.54416 3.5 3.5 9.54416 3.5 17C3.5 24.4558 9.54416 30.5 17 30.5C24.4558 30.5 30.5 24.4558 30.5 17C30.5 9.54416 24.4558 3.5 17 3.5ZM0.5 17C0.5 7.8873 7.8873 0.5 17 0.5C26.1127 0.5 33.5 7.8873 33.5 17C33.5 26.1127 26.1127 33.5 17 33.5C7.8873 33.5 0.5 26.1127 0.5 17Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.2714C19.3196 16.2714 21.2 14.4198 21.2 12.1357C21.2 9.85162 19.3196 8 17 8C14.6805 8 12.8 9.85162 12.8 12.1357C12.8 14.4198 14.6805 16.2714 17 16.2714Z",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0952 17.4531H22.0516C21.4565 17.4531 20.8613 17.5982 20.3242 17.8595L18.7274 18.658C17.6387 19.1951 16.3758 19.1951 15.2871 18.6725L13.6177 17.8595C13.0806 17.5982 12.5 17.4676 11.9048 17.4676C9.74193 17.4676 8 19.2096 8 21.3726C8 23.2513 9.24864 24.9249 11.0858 25.3178C15.4297 26.2469 18.6991 26.2102 22.9125 25.3102C24.7478 24.9181 26 23.2493 26 21.3726C26 19.1951 24.2435 17.4531 22.0952 17.4531Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaceholderAvatar);
export default __webpack_public_path__ + "static/media/ic_placeholder_avatar.344c137a762bfc22a52b07f765be4aa3.svg";
export { ForwardRef as ReactComponent };